import { FC } from 'react';
import { DividerStyled } from './style';

const Divider: FC<{ children?: any }> = ({ children, ...restProps }) => (
  <DividerStyled {...restProps}>{children}</DividerStyled>
);

export default Divider;
